import { AppDispatch } from "@/data/config/store-config";
import { useDispatch } from "react-redux";

export const useAppDispatch = () => useDispatch<AppDispatch>();